import { yup } from '@guiker/yup-util'

export const getTemplatesQueryParams = yup.object({
  listingIds: yup.array(yup.string()).nullable().default([]),
  userIds: yup.array(yup.string()).nullable().default([]),
})

export type GetTemplatesQueryParams = yup.InferType<typeof getTemplatesQueryParams>
